export const issueSideBarNodes = view => [
  view.state.schema.nodes.grid.createAndFill({}, [
    view.state.schema.nodes.grid_column.createAndFill({width: 6},
        view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('Key', view.state.schema.marks.strong.create()))),
    view.state.schema.nodes.grid_column.createAndFill({width: 10},
        view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('${key}')))
  ]),
  view.state.schema.nodes.paragraph.create(),
  view.state.schema.nodes.accordion.createAndFill({}, [
    view.state.schema.nodes.accordion_title.createAndFill({},
        view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('Dates', view.state.schema.marks.strong.create()))),
    view.state.schema.nodes.accordion_content.createAndFill({},
        view.state.schema.nodes.grid.createAndFill({}, [
          view.state.schema.nodes.grid_column.createAndFill({width: 6},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('Created on', view.state.schema.marks.strong.create()))),
          view.state.schema.nodes.grid_column.createAndFill({width: 10},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('${swf:createdOn}', view.state.schema.marks.relative_time.create({
                datetime: '${swf:createdOn}'
              })))),
          view.state.schema.nodes.grid_column.createAndFill({width: 6},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('Updated on', view.state.schema.marks.strong.create()))),
          view.state.schema.nodes.grid_column.createAndFill({width: 10},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('${swf:updatedOn}', view.state.schema.marks.relative_time.create({
                datetime: '${swf:updatedOn}'
              })))),
        ])
    )
  ]),
  view.state.schema.nodes.paragraph.create(),
  view.state.schema.nodes.accordion.createAndFill({}, [
    view.state.schema.nodes.accordion_title.createAndFill({},
        view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('People', view.state.schema.marks.strong.create()))),
    view.state.schema.nodes.accordion_content.createAndFill({},
        view.state.schema.nodes.grid.createAndFill({}, [
          view.state.schema.nodes.grid_column.createAndFill({width: 6},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('Created by', view.state.schema.marks.strong.create()))),
          view.state.schema.nodes.grid_column.createAndFill({width: 10},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('${swf:createdBy.fullName}'))),
          view.state.schema.nodes.grid_column.createAndFill({width: 6},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('Updated by', view.state.schema.marks.strong.create()))),
          view.state.schema.nodes.grid_column.createAndFill({width: 10},
              view.state.schema.nodes.paragraph.createAndFill({}, view.state.schema.text('${swf:updatedBy.fullName}'))),
        ]))
  ])
];